__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "waf-errorpage";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@el2/icons", "0.2.15", () => (Promise.all([__webpack_require__.e(442), __webpack_require__.e(792), __webpack_require__.e(534)]).then(() => (() => (__webpack_require__(4442))))));
			register("@el2/theme", "0.1.46", () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(459), __webpack_require__.e(792), __webpack_require__.e(336), __webpack_require__.e(73)]).then(() => (() => (__webpack_require__(3459))))));
			register("@el2/verlag-font", "0.1.22", () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(3935))))));
			register("@emotion/react", "11.11.1", () => (Promise.all([__webpack_require__.e(240), __webpack_require__.e(788)]).then(() => (() => (__webpack_require__(8788))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(587), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(587))))));
			register("@mui/lab", "5.0.0-alpha.133", () => (Promise.all([__webpack_require__.e(687), __webpack_require__.e(426), __webpack_require__.e(832), __webpack_require__.e(787), __webpack_require__.e(773), __webpack_require__.e(301), __webpack_require__.e(527), __webpack_require__.e(296), __webpack_require__.e(611)]).then(() => (() => (__webpack_require__(787))))));
			register("@mui/material", "5.13.4", () => (Promise.all([__webpack_require__.e(687), __webpack_require__.e(426), __webpack_require__.e(832), __webpack_require__.e(240), __webpack_require__.e(938), __webpack_require__.e(457), __webpack_require__.e(773), __webpack_require__.e(301), __webpack_require__.e(527), __webpack_require__.e(296), __webpack_require__.e(250)]).then(() => (() => (__webpack_require__(6457))))));
			register("date-fns", "2.30.0", () => (Promise.all([__webpack_require__.e(192), __webpack_require__.e(738)]).then(() => (() => (__webpack_require__(6192))))));
			register("i18next-browser-languagedetector", "7.2.1", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(1486))))));
			register("i18next", "23.11.3", () => (__webpack_require__.e(270).then(() => (() => (__webpack_require__(1270))))));
			register("jsencrypt", "3.3.2", () => (__webpack_require__.e(261).then(() => (() => (__webpack_require__(1261))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(7682))), 1);
			register("react-i18next", "13.5.0", () => (__webpack_require__.e(922).then(() => (() => (__webpack_require__(8922))))));
			register("react-router-dom", "6.12.1", () => (__webpack_require__.e(115).then(() => (() => (__webpack_require__(2115))))));
			register("react-transition-group", "4.4.5", () => (Promise.all([__webpack_require__.e(616), __webpack_require__.e(773)]).then(() => (() => (__webpack_require__(2616))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(4274))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};